import { Helmet } from 'react-helmet-async';
import * as Acc from './ui/accordion';
import { SITE } from '../data/site';

export function FAQ({ faqs, title = 'Frequently asked questions', eyebrow = 'FAQ' }) {
  const ld = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };
  return (
    <section className="py-16 sm:py-20 border-t border-slate-200" data-testid="faq-section">
      <Helmet><script type="application/ld+json">{JSON.stringify(ld)}</script></Helmet>
      <div className="container-x">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-10">
          <div>
            <p className="eyebrow text-signal mb-3">{eyebrow}</p>
            <h2 className="display text-3xl sm:text-4xl text-ink">{title}</h2>
            <p className="mt-4 text-slate-600 max-w-md leading-relaxed">
              Direct answers for procurement professionals. For anything else, email{' '}
              <a href={`mailto:${SITE.email}`} className="text-signal link-sweep" data-testid="faq-email-link">{SITE.email}</a>{' '}
              or call {SITE.phone}.
            </p>
          </div>
          <Acc.Accordion type="single" collapsible className="border-t border-slate-200" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <Acc.AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200">
                <Acc.AccordionTrigger className="text-left font-display font-semibold text-base sm:text-lg text-ink hover:text-signal hover:no-underline py-5" data-testid={`faq-question-${i}`}>
                  {f.q}
                </Acc.AccordionTrigger>
                <Acc.AccordionContent className="text-slate-600 leading-relaxed pb-5" data-testid={`faq-answer-${i}`}>
                  {f.a}
                </Acc.AccordionContent>
              </Acc.AccordionItem>
            ))}
          </Acc.Accordion>
        </div>
      </div>
    </section>
  );
}
